import { useQuery } from "@tanstack/react-query";
import { useAuth } from "./use-auth";
import type { PageAccess } from "@shared/schema";

export function usePageAccess() {
  const { user } = useAuth();
  
  return useQuery<PageAccess[]>({
    queryKey: ["/api/page-access/role", user?.role || "user"],
    enabled: !!user?.role,
    queryFn: async () => {
      const res = await fetch(`/api/page-access/role/${user?.role || "user"}`, {
        credentials: "include",
      });
      
      if (!res.ok) {
        throw new Error("Failed to fetch page access");
      }
      
      return await res.json();
    },
  });
}

export function useCanAccessPage(pageName: string) {
  const { data: accessiblePages, isLoading } = usePageAccess();
  
  if (isLoading || !accessiblePages) {
    return false;
  }
  
  return accessiblePages.some(page => page.pageName === pageName);
}